<template>
  <div class="main-conent main-conent-maxheight">
    <wuhua v-if="isIframe" :width="width" :height="height"></wuhua>
    <div v-else class="main-content-cols">
      <side-menu
        v-if="menus.length > 1"
        :menus="menus"
        :actived="actived"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body">
        <div class="monitor-player-wrap">
          <div class="monitor-player-body" :style="style">
            <ys
              v-if="isYs"
              :loading="loading"
              :device="device"
              :channels="activeAddress"
              :token="token"
              :width="width"
              :height="height"
            ></ys>
            <lec
              v-else
              :loading="loading"
              :device="device"
              :width="width"
              :height="height"
            ></lec>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAddress } from '@/service/camera'
import SideMenu from '@/components/MainSideMenu'
import monitors from '@/assets/monitors.json'
const Ys = () => import('./Ys/player')
const Wuhua = () => import('./wuhua')
const Lec = () => import('./Lec')
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'

export default {
  components: { SideMenu, Ys, Lec, Wuhua },
  data() {
    return {
      loading: false,
      address: [],
      token: '',
      width: 0,
      height: 0,
      actived: 0
      // menus: []
    }
  },
  computed: {
    isYs() {
      return Boolean(this.token)
    },
    isIframe() {
      return Boolean(monitors.find(m => m.companyId === +this.companyId))
    },
    device() {
      let camera = this.cameras[this.actived]
      if (camera) {
        return this.address.find(
          a =>
            (a.key === camera.key && a.status === 1) ||
            a.deviceId === camera.key
        )
      } else {
        return {}
      }
    },
    style() {
      return `width: ${this.width}px;height: ${this.height}px;`
    },
    activeAddress() {
      const camera = this.menus[this.actived]
      return camera ? camera.address : []
    },
    menus() {
      let arr = []
      let adrs = this.address
        .filter(adr => {
          return (
            adr.related &&
            (adr.key !== 'G98802429' ||
              (adr.key === 'G98802429' && adr.channel !== 17))
          )
        })
        .sort((a, b) => {
          return a.channel > b.channel ? 1 : a.channel < b.channel ? -1 : 0
        })
      this.cameras.forEach(cam => {
        let _adrs = adrs.filter(adr => adr.key === cam.key)
        if (_adrs && _adrs[0]) {
          arr = arr.concat(
            _adrs.map((adr) => ({
              // title: idx === 0 ? cam.name : `${cam.name} [${adr.channel}]`,
              title: adr.channelName,
              address: [adr]
            }))
          )
        } else {
          arr.push({ title: cam.name, address: [] })
        }
      })
      return arr
    }
  },
  mounted() {
    this.layout()
    addResizeListener(this.$el, this.layout)
    // this.menus = this.cameras.map(m => ({ title: m.name }))
    this.getAddress()
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.layout)
  },
  methods: {
    deviceChange(actived) {
      this.actived = actived
    },
    layout() {
      const RATIO = 16 / 9
      const { clientWidth: w, clientHeight: h } = this.$el
      const baseHeight = w / RATIO
      const isOverHeight = baseHeight > h
      this.width = isOverHeight ? h * RATIO : w
      this.height = isOverHeight ? h : Math.floor(w / RATIO)
    },
    async getAddress() {
      this.loading = true
      const { data } = await getAddress(this.companyId)

      if (data.token) {
        this.address = data.cameras.filter(c => c.status === 1)
        this.token = data.token
      } else {
        this.address = data
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content-cols__body {
  width: 100%;
  overflow: hidden;
  background-color: #000;
  .monitor-player-wrap {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  .monitor-player-body {
    background-color: #4c4b4b;
  }
}
</style>
